import { initAdminObservability } from '@trailup/observability/browser'
import { getAdminRuntimeConfig } from '../config/runtime-config'

export function initAdminSentry(): void {
  const config = getAdminRuntimeConfig()
  if (!config.sentryEnabled) {
    return
  }

  if (!config.sentryDsn?.trim()) {
    throw new Error('Sentry is enabled but sentryDsn is empty')
  }

  initAdminObservability({
    dsn: config.sentryDsn,
    environment: config.sentryEnvironment ?? 'development',
    release: config.sentryRelease ?? 'local',
    tracesSampleRate: normalizeSampleRate(config.sentryTracesSampleRate, 0.1),
  })
}

function normalizeSampleRate(
  value: number | undefined,
  fallback: number
): number {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return fallback
  }

  if (value < 0 || value > 1) {
    return fallback
  }

  return value
}
